// src/pages/delivery/DeliveryReturnsPage.jsx
import React from "react";
import DeliveryReturnsList from "../../components/delivery/DeliveryReturnsList";

const DeliveryReturnsPage = () => {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Return Requests</h1>
        <p className="text-gray-600 mt-1">
          Manage book return pickups and track return status
        </p>
      </div>
      <DeliveryReturnsList />
    </div>
  );
};

export default DeliveryReturnsPage;
